module.exports = __webpack_public_path__ + "images/emoji/clapper.e87d601d3509887a1da7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clapper.png
// module id = k738
// module chunks = 24